import { Attachment } from '../../../shared-components/models/attachment.model';

export class AttendanceCheckInOut {
    Type: string;
    Time: string;
    Status: string;
    StudentNumber: string;
    StudentLastName: string;
    StudentFirstName: string;
    StudentMiddleName: string;
    StudentId: number;
    Period: string;
    Minutes: number;
    Attachment: boolean;
    HistoryId: number;
    SubmissionId: number;
    Attachments: Attachment[] = [];
    Reason: string;
    SubmittedBy: string;
    SubmittedOn: Date;
    Date: Date;
    Code: string;

    // Non DTO Field
    Name: string;
}

export class CheckInOutSettings {
    Type: string;
    Time: string;
    PriorPeriodCodeId: string;
    OverwriteExistingAttendanceCode: boolean;
    DailyComment: string;
    UpdatePeriodComment: boolean;
    PeriodCommentAppOROver: string;
    UpdateDailyComment: boolean;
    DailyCommentAppOROver: string;
}
